<dialog-wrapper
    [backgroundColor]="'#41474f'"
    [dialogTitle]="'Section Settings'"
    [smallTitle]="true"
    [titleHeight]="40"
    [giveMeTen]="true"
    [maxHeight]="maxHeight"
    [tiny]="true"
    [hideBottom]="true"
    [showClose]="true"
    (close)="close()">
    <div class="sections">
      <div class="section">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Use a different Section Currency'" [toggled]="settings.useCurrency" (toggle)="toggleUseCurrency()" [addSpacer]="true"></toggle-tab>
        <div class="line-holder" *ngIf="settings.useCurrency">
          <div class="line-label" >Section Currency:</div>
          <div style="flex:1;"></div>
          <dropdown 
            [showSearch]="true"
            [selections]="currencyOptions" 
            [selected]="currencyOptions | findById:settings?.currency" 
            [null_text]="'Select'"
            (select)="updateCurrency($event.id)"
          ></dropdown>
        </div>
        <div class="line-holder" *ngIf="settings.useCurrency && !!settings.currency && settings.currency !== data.budgetCurrency">
          <div class="conversion-label">Conversion Rate ({{ settings.currency }}:{{ data.budgetCurrency }}):</div>
          <div style="flex:1;"></div>
          <joi-input class="conversion-rate"
            [(model)]="settings.conversionRate" 
            [placeholder]="'Rate'"
            [allowableCharacters]="'0123456789.'"
          ></joi-input>
        </div>
      </div>
      <div class="section">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Consumption Tax, VAT, or GST'" [toggled]="settings.useTax" (toggle)="settings.useTax = !settings.useTax" [addSpacer]="true"></toggle-tab>
        <div class="line-holder" *ngIf="settings.useTax">
          <div class="line-label">Tax rate:</div>
          <div style="flex:1;"></div>
          <percent-box [percent]="settings.taxRate | prettyNumbers:2:100" (onChange)="updateRate('taxRate', $event)"></percent-box>
        </div>
        <div class="line-holder" *ngIf="settings.useTax">
          <div class="line-label">Amounts are:</div>
          <div style="flex:1;"></div>
          <dropdown
            [selections]="taxOptions"
            [selected]="selectedTaxOption"
            [null_text]="'Select'"
            (select)="selectTaxOption($event)"
          ></dropdown>
        </div>
        <tip-text *ngIf="settings.useTax && !hideTaxTip" 
          [showClose]="true"
          [type]="'tip'" 
          [head]="'Tip:'" 
          [body]="'Tax will be calculated on the selected line items and be displayed as a single number in the totals block.'"
          (close)="hideTip('tax')"></tip-text>
      </div>
      <div class="section">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Discount'" [toggled]="settings.useDiscount" (toggle)="settings.useDiscount = !settings.useDiscount" [addSpacer]="true"></toggle-tab>
        <div class="line-holder" *ngIf="settings.useDiscount">
          <div class="line-label" >Discount rate:</div>
          <div style="flex:1;"></div>
          <percent-box [percent]="settings.discountRate | prettyNumbers:2:100" (onChange)="updateRate('discountRate', $event)"></percent-box>
        </div>
        <tip-text *ngIf="settings.useDiscount && !hideDiscountTip" 
          [showClose]="true"
          [type]="'tip'" 
          [head]="'Tip:'" 
          [body]="'Discount will be calculated on the selected line items and be displayed as a single number in the totals block.'"
          (close)="hideTip('discount')"></tip-text>
      </div>
      <ng-container *ngIf="data.showFees || data.showMarkup || data.showUnitRate">
        <hr class="divider"/>
        <h5 id="internal">INTERNAL ONLY</h5>
      </ng-container>

      <div class="section" *ngIf="data.showFees">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Fees'" [toggled]="settings.useFees" (toggle)="settings.useFees = !settings.useFees" [addSpacer]="true"></toggle-tab>
        <div class="line-holder" *ngIf="settings.useFees">
          <div class="line-label" >Fee rate:</div>
          <div style="flex:1;"></div>
          <percent-box [percent]="settings.feeRate | prettyNumbers:2:100" (onChange)="updateRate('feeRate', $event)"></percent-box>
        </div>  
        <tip-text *ngIf="settings.useFees && !hideFeesTip"
          [showClose]="true"
          [type]="'tip'" 
          [head]="'Tip:'" 
          [body]="'Fees will be calculated on the selected line items and be displayed as a single number in the totals block.'"
          (close)="hideTip('fees')"></tip-text>
      </div>
      <div class="section" *ngIf="data.showMarkup">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Apply Markup'" [toggled]="settings.useMarkup" (toggle)="toggleMarkup()" [addSpacer]="true"></toggle-tab>
        <div class="line-holder" *ngIf="!!settings.useMarkup">
          <div class="line-label" >Revenue Markup:</div>
          <div style="flex:1;"></div>
          <percent-box [percent]="settings.markupRate | prettyNumbers:2:100" (onChange)="updateRate('markupRate', $event)"></percent-box>
        </div>
        <tip-text *ngIf="settings.useMarkup && !hideMarkupTip" 
          [showClose]="true"
          [type]="'tip'" 
          [head]="'Tip:'" 
          [body]="'Markup will be applied to a linked revenue section for line items with the markup toggled on.'"
          (close)="hideTip('markup')"></tip-text>
      </div>
      <div class="section" *ngIf="data.showUnitRate">
        <toggle-tab [hideToggle]="data.readOnly" [borderless]="true" [text]="'Show Revenue Unit Rate'" [toggled]="settings.useUnitRate" (toggle)="settings.useUnitRate = !settings.useUnitRate" [addSpacer]="true"></toggle-tab>
        <tip-text *ngIf="settings.useUnitRate && !hideUnitRateTip"
          [showClose]="true"
          [type]="'tip'" 
          [head]="'Tip:'" 
          [body]="'This allows you to set a specific unit rate for line items of a linked revenue section (which does not have markup toggled on).'" 
          (close)="hideTip('unitrate')"></tip-text>
      </div>


    </div>
  </dialog-wrapper>